import * as React from 'react';

import { Button, Divider, Form, Typography } from 'antd';

import { CheckOutlinedIcon } from 'components';

const WatermarkFormAction = () => (
  <div>
    <div className='px-6 pt-4'>
      <Typography.Title level={3} className='mb-0 text-base font-medium'>
        انتشار نهان‌نگاری
      </Typography.Title>
    </div>

    <Divider className='mb-8 mt-4' />

    <div className='px-6'>
      <Typography.Paragraph>
        از طریق این بخش می‌توانید نهان‌نگاری ساخته شده و یا ویرایش شده را منتشر
        کنید.
      </Typography.Paragraph>
    </div>

    <div className='flex flex-wrap-reverse items-center gap-2 p-6 *:m-0 *:shrink *:grow *:basis-40'>
      <Form.Item>
        <Button
          block
          type='primary'
          htmlType='submit'
          icon={<CheckOutlinedIcon />}
        >
          ذخیره تغییرات
        </Button>
      </Form.Item>
    </div>
  </div>
);

export { WatermarkFormAction };
